import { API_URL } from "../config/api";

export const getProjectMeetingNotes = async (token: string, project_id: string): Promise<ProjectMeetingNotesInterface> => {
  try {
    const r = await fetch(`${API_URL}/projects/${project_id}/meeting-notes?size=1000`, {
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const data:ProjectMeetingNotesInterface = await r.json();

    console.log('📥 API GET meeting notes response details:', {
      total: data.total,
      resultsCount: data.results?.length,
      allFieldsInFirstItem: data.results?.[0] ? Object.keys(data.results[0]) : [],
      allRecordsWithFields: data.results?.map((item, index) => ({
        index,
        id: item.id,
        hasDate: 'date' in item,
        dateValue: item.date,
        allFields: Object.keys(item),
        customers: Array.isArray(item.customers) ? `Array(${item.customers.length})` : typeof item.customers,
        vendors: Array.isArray(item.vendors) ? `Array(${item.vendors.length})` : typeof item.vendors
      }))
    });

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const getProjectMeetingNoteById = async (token: string, project_id: string, item_id: string): Promise<ProjectMeetingNote> => {
  try {
    const r = await fetch(`${API_URL}/projects/${project_id}/meeting-notes/${item_id}`, {
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const data:ProjectMeetingNote = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
}

export const createProjectMeetingNote = async (token: string, project_id: string, data: ProjectMeetingNote): Promise<ProjectMeetingNote> => {
  try {
    console.log('🔄 API POST request data:', JSON.stringify(data, null, 2));
    const r = await fetch(`${API_URL}/projects/${project_id}/meeting-notes`,{
      method: 'POST',
      headers: {
        'Content-Type':'application/json',
        'authorization': 'Bearer ' + token
      },
      body: JSON.stringify(data)
    })

    console.log('📤 API POST response status:', r.status, r.statusText);

    if (!r.ok) {
      const errorText = await r.text();
      console.error('❌ API POST error response:', errorText);
      throw new Error(r.statusText);
    }
    const res:any = await r.json();
    console.log('📥 API POST response data:', res);

    return res;
  } catch(e: Error | any) {
    console.error('🚨 API POST error:', e);
    throw new Error(e);
  }
}

export const updateProjectMeetingNotes = async (token: string, project_id: string, item_id: string, data: ProjectMeetingNote): Promise<any> => {
  try {
    console.log('🔄 API PUT request data:', JSON.stringify(data, null, 2));
    const res = await fetch(`${API_URL}/projects/${project_id}/meeting-notes/${item_id}`,{
      method: 'PUT',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      },
      body: JSON.stringify(data)
    })

    console.log('📤 API PUT response status:', res.status, res.statusText);

    if (!res.ok) {
      const errorText = await res.text();
      console.error('❌ API PUT error response:', errorText);
      throw new Error(res.statusText);
    }

    // Try to parse response body if available
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const responseData = await res.json();
      console.log('📥 API PUT response data:', responseData);
      return responseData;
    }

    console.log('✅ API PUT success (no response data)');
    return res;
  } catch(e: Error | any) {
    console.error('🚨 API PUT error:', e);
    throw new Error(e);
  }
};

export const deleteProjectMeetingNotes = async (token: string, project_id: string, item_id: string): Promise<any> => {
  try {
    const res = await fetch(`${API_URL}/projects/${project_id}/meeting-notes/${item_id}`,{
      method: 'DELETE',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })

    if (!res.ok) {
      throw new Error(res.statusText);
    }

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const getProjectMeetingNoteTypes = async (token: string): Promise<ProjectMeetingNoteTypesPageInterface> => {
  try {
    const r = await fetch(`${API_URL}/projects/meeting-types`, {
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const data:ProjectMeetingNoteTypesPageInterface = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const createProjectMeetingNoteTypes = async (token: string, dataObj: ProjectMeetingNoteTypesInterface): Promise<{id: string}> => {
  try {
    const r = await fetch(`${API_URL}/projects/meeting-types`, {
      method: 'POST',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      },
      body: JSON.stringify(dataObj)
    })
    const data:any = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const getProjectMeetingNoteTypeById = async (token: string, meeting_type_id: string): Promise<ProjectMeetingNoteTypesInterface> => {
  try {
    const r = await fetch(`${API_URL}/projects/meeting-types/${meeting_type_id}`, {
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const data:ProjectMeetingNoteTypesInterface = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const updateProjectMeetingNoteType = async (token: string, meeting_type_id: string, dataObj: ProjectMeetingNoteTypesInterface): Promise<ProjectMeetingNoteTypesInterface> => {
  try {
    const r = await fetch(`${API_URL}/projects/meeting-types/${meeting_type_id}`, {
      method: 'PUT',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      },
      body: JSON.stringify(dataObj)
    })
    const data:ProjectMeetingNoteTypesInterface = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const deleteProjectMeetingNoteType = async (token: string, meeting_type_id: string): Promise<any> => {
  try {
    const r = await fetch(`${API_URL}/projects/meeting-types/${meeting_type_id}`, {
      method: 'DELETE',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })

    if (!r.ok) {
      throw new Error(r.statusText);
    }

    return r;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};
